export const correctingEpochNomenclature = (
  fromSize: number,
  toSize: number,
  epoch: number
): number => {
  if (epoch === 0) {
    return 0;
  }

  const indexFrom = fromSize / 30;
  const indexTo = toSize / 30;
  const floorValue = Math.floor((epoch * indexFrom) / indexTo);

  return floorValue < 0 ? 0 : floorValue;
};
